import { Link } from 'react-router'

export default function MiniSiteFooter() {
  // oxlint-disable-next-line react/purity -- the copyright year intentionally follows the current time
  const year = new Date().getFullYear()

  return (
    <footer className='pt-8 pb-6 sm:pb-3'>
      <div className='container'>
        <div className='flex flex-col items-center gap-1 text-secondary md:flex-row md:justify-center md:gap-1.5 md:space-y-0 lg:gap-3'>
          <div className='whitespace-nowrap'>&copy; {year} PlanetScale Inc. All rights reserved.</div>

          <div className='flex justify-center gap-1 sm:justify-start'>
            <Link className='text-primary' prefetch='intent' rel='nofollow' to='/legal/privacy'>
              Privacy
            </Link>

            <Link className='text-primary' prefetch='intent' rel='nofollow' to='/legal/siteterms'>
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
